import { render, staticRenderFns } from "./ContentFooter.vue?vue&type=template&id=ac563d0e&scoped=true"
import script from "./ContentFooter.vue?vue&type=script&lang=js"
export * from "./ContentFooter.vue?vue&type=script&lang=js"
import style0 from "./ContentFooter.vue?vue&type=style&index=0&id=ac563d0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac563d0e",
  null
  
)

export default component.exports